// tslint:disable
export var EnrollmentType;
(function (EnrollmentType) {
    // If Membernumber type is Unknown
    EnrollmentType[EnrollmentType["Unknown"] = 0] = "Unknown";
    // Medical MemberNumber
    EnrollmentType[EnrollmentType["Medical"] = 6] = "Medical";
    // Pharmacy MemberNumber
    EnrollmentType[EnrollmentType["Pharmacy"] = 7] = "Pharmacy";
})(EnrollmentType || (EnrollmentType = {}));
EnrollmentType['UNKNOWN'] = 0;
EnrollmentType['MEDICAL'] = 6;
EnrollmentType['PHARMACY'] = 7;
//# sourceMappingURL=EnrollmentType.js.map